<template>
  <div :class="modalClass" tabindex="-1" role="dialog" id="workflowDetailsModal">
    <div class="modal-dialog modal-lg" role="document" id="workflowDetailsModalDialog">
      <div class="modal-content" :style="borderRadius ? 'border-radius: ' + borderRadius + 'px' : ''">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" :aria-label="_('Close')" v-on:click="close"><span aria-hidden="true">&times;</span></button>
          <div class="pull-right">{{ displayedDate }}&nbsp;</div>
          <h4 class="modal-title"><i :class="'workflow-pin fa fa-fw clickable fa-star' + (parseInt(order.pinned) ? ' pinned' : '-o not-pinned')" v-on:click="pin()"></i><span class="workflow-titletext">{{_('Order')}} {{ order.id }}: {{ order.name || order.pos_name || _('Johku APP') }}<span v-if="order.billing_company"> / {{ order.billing_company }}</span></span></h4>
          <div class="header-statuses">
            <span class="label label-success" v-if="order.payment != 'open' && parseInt(order.paid)">{{ _('Paid') }}</span>
            <span class="label label-warning" v-if="order.payment != 'open' && !parseInt(order.paid)">{{ _('Not paid') }}</span>
            <span class="label label-info" v-if="order.payment == 'open'">{{ _('Open order') }}</span>
            <span class="label label-default" v-if="parseInt(order.confirmed) === 1">{{ _('Confirmed') }}</span>
          </div>
        </div>
        <div class="modal-body" id="workflowDetailsModalBody">
          <div class="order-tags">
            <div class="columns">
              <button type="button" :class="'btn btn-' + (isWorkflowColumnSelected(index) ? 'dark' : 'default')" v-for="(workflowColumn, index) in workflowColumns" v-on:click="workflowColumnClicked(index)">{{ workflowColumn.title }}</button>
            </div>
            <button type="button" class="btn btn-labeled btn-default pull-right" v-if="!parseInt(order.processed)" v-on:click="setProcessed()"><span class="btn-label"><i class="glyphicon glyphicon-unchecked"></i></span>{{ _('Processed') }}</button>
            <button type="button" class="btn btn-labeled btn-success pull-right" v-else v-on:click="setNotProcessed()"><span class="btn-label"><i class="glyphicon glyphicon-check"></i></span>{{ _('Processed') }}</button>
          </div>
          <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
          <div class="modal-tabs"><!-- Why not have order stuff also accessible when using the delivery flow, via this tab navi  -->
            <editor-tabs :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
          </div>
          <div class="tab-content">
            <transition name="fade" mode="out-in">
              <div v-bind="tabPanel('order')" class="tab-pane active" id="order" v-if="isTabActive('order')" key="order">
                <h4>{{ _('Order') }} {{ order.id }}</h4>
                <div v-show="itemsWithoutDiscounts.length" class="order-items receipt-items">
                  <cart-item parent="orderdetails" :readonly="true" :settings="shopSettings(shopId)" :shopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="item" v-for="item in itemsWithoutDiscounts" :key="item.id" leftcolwidth="0" rightcolwidth="12" context="page"></cart-item>
                </div>
                <p><strong>{{_('Total')}}: {{ $filters.currency(order.totalWithDelivery, settings.currency) }}</strong></p>
              </div>
            </transition>
            <!-- Order info -->
            <div class="row">
              <div class="col-sm-8">
                <editor-tabs style="margin-top: 10px" :tabs="subTabList" :selected="activeSubTab" v-on:select="subTab" />
                <transition-group>
                  <div role="tabpanel" class="tab-pane active" v-if="isSubTabActive('notes')" key="notes">
                    <h4>{{ _('Notes') }}</h4>
                    <textarea spellcheck="false" class="form-control" rows="4" wrap="virtual" v-model="notes"></textarea>
                    <button type="button" class="btn btn-success" v-if="editedNotes != null && editedNotes != order.notes" v-on:click="saveNotes">{{ _('Save') }}</button>
                  </div>
                  <div role="tabpanel" class="tab-pane active" v-if="isSubTabActive('more')" key="more">
                    <h4>{{ _('More details') }}</h4>
                    <textarea spellcheck="false" class="form-control" rows="4" wrap="virtual" :value="more" readonly></textarea>
                  </div>
                  <div role="tabpanel" class="tab-pane active" v-if="isSubTabActive('formresponses') && isFeatureEnabled('forms')" key="formresponses">
                    <h4>{{ _('Forms') }}</h4>
                    <div v-for="formresponse in formresponses">
                      <div v-for="(answer, question) in formresponse" :key="question" class="formresponse-question">
                        <strong>{{ question }}:</strong> <span>{{ answer }}</span>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </div>
              <div class="col-sm-4">
                <h4>{{ _('Order highlights') }}</h4>
                <div class="workflow-products-resources">
                  <span class="label label-default productname-hilite name-hilite" v-for="item in productNames">{{ item }}</span>
                  <span class="label label-default resourcename-hilite name-hilite" v-for="item in resourceNames" v-html="formatResourceName(item)"></span>
                </div>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-sm-6">
                <h4></h4>
                <div v-if="order.name">{{ order.name }}</div>
                <div v-if="order.company">{{ order.company }}</div>
                <div v-if="order.ident">{{ order.ident }}</div>
                <div v-if="order.address">{{ order.address }}</div>
                <div v-if="order.zip || order.city">{{ order.zip }} {{ order.city }}</div>
                <div v-if="order.country && order.country != 'FI'">{{ order.country }}</div>
                <div v-if="order.phone">{{ order.phone }}</div>
                <div v-if="order.email">{{ order.email }}</div>
                <div v-else>{{ _('Johku App') }}</div>
              </div>
              <div class="col-sm-6">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="flex-row space-between">
              <div class="flex-row">
                <button class="btn btn-primary" v-on:click="displayOrder"><i class="fa fa-fw fa-shopping-cart"></i> {{ _('Show order') }}</button>
                <button class="btn btn-primary" v-on:click="modifyOrder" v-if="isModifyOrderAvailable"><i class="fa fa-fw fa-pencil-square-o"></i> {{ _('Edit order') }}</button>
                <button class="btn btn-primary" v-on:click="printManifest" v-if="isPrintManifestAvailable"><i class="fa fa-fw fa-print"></i> {{ _('Print delivery manifest') }}</button>
              </div>
              <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="close">{{ _('Close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import componentlocks from '~/lib/componentlocks'
import events from '~/lib/events'
import settingshelpers from '~/lib/settingshelpers'
import CartItem from '~/components/CartItem'
import { mapGetters } from 'vuex'
import axios from 'axios'
import { DateTime } from 'luxon'
import tabs from '~/lib/tabs'
import LockInfo from '~/components/LockInfo'

export default {
  props: ['column', 'workflowColumns', 'borderRadius', 'order', 'tags'],
  data () {
    return {
      editedNotes: null,
      component: {
        type: 'OrderDetails', // This is not actually OrderDetails, but we use this for the locking system
        initData: {
          activateTab: 'order'
        }
      },
      pinned: false,
      activeSubTab: 'notes'
    }
  },
  mixins: [componentlocks, events, settingshelpers, tabs],
  computed: {
    subTabList () {
      return [
        { id: 'notes', label: this._('Notes'), badge: this.notes ? 1 : null },
        { id: 'more', label: this._('More details'), badge: this.more ? 1 : null },
        { id: 'formresponses', label: this._('Forms'), badge: this.formresponses.length, hidden: !this.isFeatureEnabled('forms') }
      ]
    },
    tabList () {
      return this.editorTabs([
        { id: 'order', label: this._('Order') }
      ])
    },
    ...mapGetters(['allSettings', 'locale', 'clientid', 'pos', 'floatingReceipt', 'apiKey', 'dateFormat', 'timeFormat', 'numberFormat']),
    settings () {
      return this.shopSettings(this.shopId)
    },
    modalClass () {
      return 'modal fade in show'
    },
    myComponentId () {
      return this.column ? this.column.identifier + '-' + this.column.component.id + '-orderdetails' : null
    },
    displayedDate () {
      if (!this.order) {
        return ''
      }
      let ts = null
      if (!this.isFeatureEnabled('delivery2.0')) {
        ts = this.order.orderdate
        return DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.dateFormat + " '" + this._('at') + "' " + DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.timeFormat))
      }
      if (!this.order.ownDelivery || !this.order.ownDelivery.length) {
        return ''
      }
      ts = Math.min(this.order.ownDelivery.filter(d => !parseInt(d.processed)).map(d => d.ts))
      if (!ts) {
        ts = Math.max(this.order.ownDelivery.filter(d => parseInt(d.processed)).map(d => d.ts))
      }
      if (!ts) {
        return ''
      }
      return DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.dateFormat + " '" + this._('at') + "' " + DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.timeFormat))
    },
    orderFullDate () {
      let ts = this.order.orderdate
      return DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.dateFormat + " '" + this._('at') + "' " + DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.timeFormat))
    },
    items () {
      if (!this.order) {
        return []
      }
      return this.order.ownItem
    },
    itemsWithoutDiscounts () {
      if (!this.order) {
        return []
      }
      return this.order.ownItem.filter(i => !i.discount_id)
    },
    notes: {
      get () {
        return this.editedNotes !== null ? this.editedNotes : this.order.notes
      },
      set (val) {
        if (!val) {
          val = ''
        }
        this.editedNotes = val
      }
    },
    more () {
      return this.order.more
    },
    formresponses () {
      if (!this.order || !this.order.ownItem || !this.order.ownItem.length) {
        return []
      }
      return this.order.ownItem.filter(item => item.formresponse).map(item => typeof item.formresponse === 'string' ? JSON.parse(item.formresponse) : item.formresponse) // The order is loaded with reservations=true, which decodes the answers
    },
    resourceNames () {
      if (!this.order || !this.order.ownItem || !this.order.ownItem.length) {
        return []
      }
      let names = []
      const items = this.order.ownItem.filter(item => item.ownReservation && item.ownReservation.length)
      items.forEach(item => {
        const reservations = item.ownReservation.filter(reservation => reservation.sharedResource)
        reservations.forEach(reservation => {
          const resources = reservation.sharedResource.filter(resource => parseInt(resource.display_name_in_workflow))
          resources.forEach(resource => {
            names.push(resource.name)
          })
        })
      })
      return names
    },
    productNames () {
      if (!this.order || !this.order.ownItem || !this.order.ownItem.length) {
        return []
      }
      return this.order.ownItem.filter(item => item.product && parseInt(item.product.display_name_in_workflow)).map(item => item.product.name)
    },
    isModifyOrderAvailable () {
      return this.floatingReceipt && this.order && this.order.payment === 'open' && !this.locked
    },
    isPrintManifestAvailable () {
      if (!this.isFeatureEnabled('manifestprinter')) {
        return false
      }
      return true
    }
  },
  methods: {
    isSubTabActive (subTab) {
      return this.activeSubTab === subTab
    },
    subTab (subTab) {
      this.activeSubTab = subTab
    },
    formatResourceName (item) {
      return item ? item.replace(/@checkedout$/, ' <i class="fa fa-fw fa-sign-out"></i>').replace(/@checkedin$/, ' <i class="fa fa-fw fa-sign-in"></i>') : ''
    },
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    getComponentItemId () {
      return this.order.id
    },
    isTagSelected (tag) {
      if (this.order && this.order.sharedTag) {
        for (let i = 0; i < this.order.sharedTag.length; i++) {
          if (this.order.sharedTag[i].id == tag.id) {
            return true
          }
        }
      }
      return false
    },
    isWorkflowColumnSelected (columnIndex) {
      return columnIndex == this.order.activeWorkflowColumn
    },
    setProcessed () {
      this.$emit('setProperty', { processed: 1 })
    },
    setNotProcessed () {
      this.$emit('setProperty', { processed: 0 })
    },
    saveNotes () {
      this.$emit('saveNotes', this.editedNotes)
    },
    displayOrder () {
      this.$emit('displayOrder', this.order)
    },
    modifyOrder () {
      this.$emit('modifyOrder', this.order)
    },
    tagClicked (tag) {
      if (this.isTagSelected(tag)) {
        return
      }
      let newTag = null
      let oldTag = null
      for (let t in this.tags) {
        if (Object.prototype.hasOwnProperty.call(this.tags, t)) {
          if (this.isTagSelected(this.tags[t])) {
            oldTag = this.tags[t]
            break
          }
        }
      }
      this.$emit('changeTag', { old: oldTag, new: tag })
    },
    workflowColumnClicked (columnIndex) {
      this.$emit('workflowColumnClicked', columnIndex)
    },
    pin () {
      this.$emit('setProperty', { pinned: parseInt(this.order.pinned) ? 0 : 1 })
    },
    close () {
      this.$emit('closeModal')
    },
    save () {
      this.$emit('saveChanges')
    },
    async printManifest () {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/orders/' + this.order.id + '/print.json?print=manifest&client=' + this.clientid + '&pos=' + this.pos + '&apikey=' + this.apiKey)
      } catch(e) {
        // We fail silently, yay?
      }
    }
  },
  components: {
    CartItem,
    LockInfo
  },
  mounted () {
    if(!this.events) {
      let events = {}
      this.events = events
    }
    this.enableEventBus()
    this.getComponentLock()
    if (this.notes) {
      this.activeSubTab = 'notes'
    } else if (this.more) {
      this.activeSubTab = 'more'
    } else if (this.formresponses.length) {
      this.activeSubTab = 'formresponses'
    }
    window.addEventListener('beforeunload', this.releaseComponentLockWrapper)
  },
  beforeUnmount () {
    this.releaseComponentLock()
    window.removeEventListener('beforeunload', this.releaseComponentLockWrapper)
  }
}
</script>